import { render, staticRenderFns } from "./Manual.vue?vue&type=template&id=a2b12008&scoped=true"
var script = {}
import style0 from "./Manual.vue?vue&type=style&index=0&id=a2b12008&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2b12008",
  null
  
)

export default component.exports